import { render, staticRenderFns } from "./SaiquHotelList.vue?vue&type=template&id=dc337b6a&scoped=true&"
import script from "./SaiquHotelList.vue?vue&type=script&lang=js&"
export * from "./SaiquHotelList.vue?vue&type=script&lang=js&"
import style0 from "./SaiquHotelList.vue?vue&type=style&index=0&id=dc337b6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc337b6a",
  null
  
)

export default component.exports